import React, { useEffect, useState } from "react";
import { getHealthCareBlogs, getHeadingFromCMS } from "../../actions/get-calls";
import { Link } from "react-router-dom";
import { APP_SUB_FOLDER, decodeString, encodeString } from "../../constants/app-constants";

const Iprops = {
    HeaderClassName:'',
    subClassName:''
}
const ShowHealthBlogs = (props = Iprops) => {
	const [healthCareblogs, setHealthCareBlogs] = useState([]);

	const fetchHealthCareBlogs = async () => {
		const response = await getHealthCareBlogs();
		setHealthCareBlogs(response.data || []);
	};

	const [heading, setHeading] = useState(null);

	useEffect(async () => {
		// Heading
		const _setHeading = await getHeadingFromCMS(1, 8);
		if (_setHeading) setHeading(_setHeading.data[0]);
		else setHeading([]);
	}, []);

	useEffect(() => {
		fetchHealthCareBlogs();
	}, []);

	return (
		<div>
			<section className="mhc-latest-news">
				<div className="container">
					<h1 className={props.HeaderClassName}>{heading ? heading.main_heading : <>Health Blogs</>}</h1>
					{(heading && heading.description) ?
						<p className={props.subClassName}dangerouslySetInnerHTML={{ __html: heading.description }}></p> :
						<p className= {props.subClassName}>At MyHealthcare, we focus on complete healthcare ecosystem solutions. Our numbers are just a reflection of the same!</p>
					}

					<div className="row justify-content-center mt-4">
						{healthCareblogs && Array.isArray(healthCareblogs) && healthCareblogs.map((healthCareBlog) => {
							return (
								<div className="col-md-6 col-lg-6 col-xl-3 mb-4" key={healthCareBlog._id}>
									<div className="mhc-latest-new-card">
										<figure className="m-0">
											<img  className="icon" src={healthCareBlog.blog_img} alt="MyHealthcare Health Blogs"  />
										</figure>
										<div className="card-body p-3 ">
										<h2>{healthCareBlog.title.substring(0, 50)}{healthCareBlog.title.length >= 50 ? '...':''}</h2>
											<p className="wrap-in-4-line mb-0">{healthCareBlog.short_description.substring(0, 90)}</p>
											
										</div>
										<div className="card-footer pb-3 px-3 pt-0">
										<Link to={`${APP_SUB_FOLDER}/health-blogs/${healthCareBlog.slug}`} className="btn btn-outline-primary rounded-1">Read More</Link>
										</div>
									</div>
								</div>
							);
						})}
					</div>
				</div>
			</section>
		</div>
	);
};

export default ShowHealthBlogs;
